import * as React from "react"
import { useState } from "react"
import "./style_3.scss"

export default function ProductContentStyle3({ items }) {
    const elementWidth = document.getElementsByClassName('progress');
    const [expanded, setExpanded] = useState({});

    return items?.map((data, index) => !!Object.keys(data)?.length && (
        <div key={index}
            className={`product-content style_3`}
        >
            <div className={`content-block-info`}>
                <div className="durability-gauge">
                    <img src={`/static/images/gauge/${+data.count}.gif`} alt="" />
                </div>

                <div className="info-data">
                    {data.info_data?.sort((a, b) => +b.scale_value - +a.scale_value)?.map((infoItem, infoIndex) => {
                       const calculateWidth = !!elementWidth[infoIndex] ? (+infoItem.scale_value * elementWidth[infoIndex]?.offsetWidth / +infoItem.scale_steps) : (+infoItem.scale_value * 396 / +infoItem.scale_steps);

                       return (!!infoItem.scale_value?.length || !!infoItem?.progress?.length) && (
                            <div key={infoIndex} className={`info-data-item`}>
                                {infoItem.progress ? (
                                    <div className="progress-info">
                                        <p className="title" onClick={() => setExpanded(prev => ({ ...prev, [infoIndex]: !expanded[infoIndex] }))}>
                                            <span>{infoItem.title}</span>
                                            <span className={`arrow ${!expanded[infoIndex] ? '' : 'expanded'}`}>
                                                <img src={"/static/images/product-arrow.svg"} alt="" />
                                            </span>
                                        </p>
                                        <p className="value">{`${infoItem.progress}%`}</p>
                                    </div>
                                ) : (
                                    <p className="title" onClick={() => setExpanded(prev => ({ ...prev, [infoIndex]: !expanded[infoIndex] }))}>
                                        <span>{infoItem.title}</span>
                                        <span className={`arrow ${!expanded[infoIndex] ? '' : 'expanded'}`}>
                                            <img src={"/static/images/product-arrow.svg"} alt="" />
                                        </span>
                                    </p>
                                )}

                                <p className={`description ${!expanded[infoIndex] ? '' : 'expanded'}`}>{infoItem.description}</p>

                                {!infoItem.progress && (
                                    <div className="scores">
                                        <div className="progress" style={{ width: `90%` }}>
                                            <div className={`progress-block ${calculateWidth}`}
                                                style={{ width: `${calculateWidth}px` }}
                                            />
                                        </div>
                                        <p className="value">
                                            {!infoItem.progress && `${infoItem.scale_value}`}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    ))
}
